import React from 'react'
import { Box, Typography } from "@mui/material"
const CopyRight = () => {
    return (
        <Box sx={{ width: "100%", textAlign: "center", color: "black" }}>
            <Box sx={{  textAlign: "center",padding:"1rem", margin: "auto" }}>
                <Typography>Copy Right By Tausif</Typography>
            </Box>
        </Box>
    )
}

export default CopyRight